import { Stack } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import Page from '@/components/layouts/Page'
import ProductionPlanObligationPeriodCard from '@/features/portfolioHierarchy/components/ProductionPlanObligationPeriodCard'
import RegulationObjectActivationGroupsDataGrid from '@/features/portfolioHierarchy/components/RegulationObjectActivationGroupsDataGrid'
import RegulationObjectCard from '@/features/portfolioHierarchy/components/RegulationObjectCard'
import { PortfolioHierarchyRouteInformation } from '@/features/portfolioHierarchy/constants'

function RegulationObjectDetails() {
  const { t } = useTranslation()
  const { countryCode, regulationObjectCode } = useParams()
  // In the future might load more details about this entity from an API, but for now we just use the two params
  const isLoading = false

  if (!countryCode || !regulationObjectCode) {
    return null
  }

  const shouldShowProductionPlanObligationPeriod = countryCode === 'FI'

  return (
    <Page
      isLoading={isLoading}
      pageHeaderProps={{
        breadcrumbItems: [
          {
            text: t('component.page_header.portfolio_hierarchy'),
            to: PortfolioHierarchyRouteInformation.INDEX.navigationPath,
          },
          {
            text: t('component.page_header.regulation_objects'),
            to: PortfolioHierarchyRouteInformation.REGULATION_OBJECTS.navigationPath,
          },
        ],
        pageTitle: t('component.page_header.regulation_object_details'),
      }}
    >
      <Stack direction="column" marginY={3} spacing={3}>
        <RegulationObjectCard countryCode={countryCode} regulationObjectCode={regulationObjectCode} />
        <RegulationObjectActivationGroupsDataGrid
          countryCode={countryCode}
          regulationObjectCode={regulationObjectCode}
        />
        {shouldShowProductionPlanObligationPeriod && (
          <ProductionPlanObligationPeriodCard countryCode={countryCode} regulationObjectCode={regulationObjectCode} />
        )}
      </Stack>
    </Page>
  )
}

export default RegulationObjectDetails
